import React from 'react';
import i18next from 'i18next';

import { TitleHeaderBlock } from '../../../components';

import Dossier from '../../Node/Dossier';

import './style.scss';

const ParagraphDossiersSelected = ({ entity }) => {
  const { t } = i18next;

  const dossiers = entity.getIn(['field_dossiers']);

  return (
    <div>
      <TitleHeaderBlock
        title={t('node.dossier.our_dossiers')}
        linkText={t('node.dossier.all')}
        linkUrl="/nl/dossiers"
      >
        {dossiers.map((dossier) => (
          <Dossier entity={dossier.get('entity')} viewMode="teaser" isLarge />
        ))}
      </TitleHeaderBlock>
    </div>
  );
};

export default ParagraphDossiersSelected;
